"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterEventHandlerEventHandlerActivator = exports.RegisterEventHandlerEventHandlerArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EventHandlerType_1 = require("../EventHandlerType");
class RegisterEventHandlerEventHandlerArgs {
    constructor(target, eventType, schedule, handler) {
        this.target = target;
        this.eventType = eventType;
        this.schedule = schedule;
        this.handler = handler;
        this.__type = EventHandlerType_1.EventHandlerType.RegisterEventHandler;
        this.__typeName = "RegisterEventHandler";
    }
}
exports.RegisterEventHandlerEventHandlerArgs = RegisterEventHandlerEventHandlerArgs;
let RegisterEventHandlerEventHandlerActivator = class RegisterEventHandlerEventHandlerActivator {
    activate(sequence, container, handler) {
        const targets = container.selectTargets(handler.subject, handler.args.target);
        for (const target of targets) {
            container.registerEventHandler(target, handler.args.eventType, handler.args.schedule, handler.args.handler);
        }
    }
};
RegisterEventHandlerEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.RegisterEventHandler)
], RegisterEventHandlerEventHandlerActivator);
exports.RegisterEventHandlerEventHandlerActivator = RegisterEventHandlerEventHandlerActivator;
